// BEN_NOTE
// this has not yet been integrated
import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import initialState from './initialState';
import mainReducer from './reducer';
//import sagaMiddleware from './saga/sagaMiddleware';
import createSagaMiddleware from 'redux-saga';
import sagas from './saga/sagas';

const sagaMiddleware = createSagaMiddleware()
const store = createStore(
  // TODO - combineReducers
  mainReducer,
  initialState,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
  // applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(sagas);

export default store;
